import { CommonModule } from '@angular/common';
import {
	DestroyRef,
	Directive,
	inject,
	Input,
	NgModule,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Directive({
	// eslint-disable-next-line @angular-eslint/prefer-standalone
	standalone: false,
	selector: '[obsValue]',
})
export class ReachObsValueDirective<T> {
	private readonly destroyRef = inject(DestroyRef);
	private templateRef = inject<TemplateRef<{ obsValue: T }>>(TemplateRef);
	private viewContainer = inject<ViewContainerRef>(ViewContainerRef);

	private newObs$$ = new Subject<void>();

	private emitted = false;

	@Input()
	public set obsValue(observable: Observable<T>) {
		this.newObs$$.next();

		this.emitted = false;

		this.addView(this._baseValue);

		observable
			.pipe(
				finalize(() => this.viewContainer.clear()),
				takeUntil(this.newObs$$),
				takeUntilDestroyed(this.destroyRef)
			)
			.subscribe((value) => {
				this.emitted = true;
				this.viewContainer.clear();
				this.addView(value);
			});
	}

	private _baseValue: T | null = null;

	@Input()
	public set obsValueBaseValue(baseValue: T) {
		this._baseValue = baseValue;

		if (!this.emitted) {
			this.addView(baseValue);
		}
	}

	onDestroy(): void {
		this.viewContainer.clear();
	}

	private addView(value: T | null): void {
		this.viewContainer.createEmbeddedView(this.templateRef, { obsValue: value });
	}
}

@NgModule({
	declarations: [ReachObsValueDirective],
	imports: [CommonModule],
	exports: [ReachObsValueDirective],
})
export class ReachObsValueModule {}
